import { Home } from "components/home/Home";
import React from "react";

const LandingPage = () => {
  return <Home />;
};

export default LandingPage;
